import { forwardRef, type SelectHTMLAttributes } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "../../lib/utils";

// Стилизованная обёртка над нативным <select>. Без поведенческих
// расширений (popup-меню и т.п.) — это сознательный выбор: нативный
// дропдаун правильно работает с клавиатурой, скрин-ридерами и мобилкой,
// а нам нужна только визуальная унификация с Input/Button. По высоте
// и border повторяет Input.
export const Select = forwardRef<
  HTMLSelectElement,
  SelectHTMLAttributes<HTMLSelectElement>
>(({ className, children, ...props }, ref) => (
  <div className="relative">
    <select
      ref={ref}
      className={cn(
        "flex h-9 w-full appearance-none rounded-md border border-input bg-background px-3 pr-8 py-1 text-sm",
        "shadow-sm transition-[box-shadow,border-color]",
        "focus-warm",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {children}
    </select>
    <ChevronDown
      aria-hidden="true"
      className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"
    />
  </div>
));
Select.displayName = "Select";
